// extracted by mini-css-extract-plugin
export var arrow = "_2n-6";
export var changeItem = "_2n-3";
export var changesHeader = "_2n-1";
export var changesList = "_2n-2";
export var container = "_2n-0";
export var pathLabel = "_2n-4";
export var value = "_2n-7";
export var valuesContainer = "_2n-5";